const home = {
  namespaced:true,
  state: () => ({
    menuVisible: false, // 是否显示菜单
    factoryData: [],
    btnList: [],
  }),
  mutations:{
    setState(state, payload) {
      for (let i in payload) {
        state[i] = payload[i]
      }
    },
  }
}

export default home